import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";

interface CompanyCircleProps {
  name: string;
  companyUrl?: string; // Optional prop for company URL
}
const CompanyCircle = ({ name, companyUrl }: CompanyCircleProps) => {
  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        position: "relative",
        my: 4,
      }}
    >
      <Box
        sx={{
          width: { xs: 40, sm: 80 },
          height: { xs: 40, sm: 80 },
          borderRadius: "50%",
          bgcolor: "#000",
          color: "white",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          textAlign: "center",
          zIndex: 1,
          border: `6px solid #fff`,
          p: 2,
        }}
      >
        <Typography
          variant="h6"
          sx={{ fontWeight: "bold", fontSize: { xs: 12, sm: 16 } }}
        >
          <a
            href={companyUrl}
            target="_blank"
            rel="noreferrer"
            style={{ color: "#fff", textDecoration: "none" }}
          >
            {name}
          </a>
        </Typography>
      </Box>
    </Box>
  );
};

export default CompanyCircle;
